module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-kaoawase-staff-3f5fdfb82fefb44b818129dba3f06ffc.png";